module.exports = __webpack_public_path__ + "static/img/b2.619fd74.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/tutorial2/b2.jpg
// module id = xVJN
// module chunks = 14